import { render, staticRenderFns } from "./LifetimePlansSection.vue?vue&type=template&id=6cc4c557&scoped=true"
import script from "./LifetimePlansSection.vue?vue&type=script&lang=js"
export * from "./LifetimePlansSection.vue?vue&type=script&lang=js"
import style0 from "./LifetimePlansSection.vue?vue&type=style&index=0&id=6cc4c557&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc4c557",
  null
  
)

export default component.exports